import Axios from '../axios'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared'
import appConfig from 'app.config'

async function GetReferalLinkService(partyId: string) {
	const { data } = await Axios.get(
		`${appConfig.customerDataBaseUrl}/api/ReferralLink/referralLink?partyId=${partyId}`,
		await getHeadersWithJwtToken()
	)
		.then((res) => {
			return res
		})
		.catch((err) => {
			console.log(err.response)
			logError(err)
			return err.response
		})
	return data
}

export default GetReferalLinkService
